import classnames from "classnames";

import {
    Breakpoint,
    LayoutContainer,
    Text,
    useGridStyles,
    domain,
    LayoutCell,
    LeadJobQualificationsView,
} from "@relode/core";
import * as React from "react";
import {
    CandidateHighlights as CandidateOverviewType,
    CandidateAdditionalInfo as CandidateAdditionalInfoType,
    CandidateJobDetails,
} from "../../types";

interface CandidateHighlightsProps {
    highlights: CandidateOverviewType;
    qualifications: domain.LeadJobQualifications;
    additionalInfo: CandidateAdditionalInfoType;
    job?: CandidateJobDetails;
    currentLeadId?: number;
}
export const CandidateHighlights = (props: CandidateHighlightsProps) => {
    const gridClasses = useGridStyles({});
    const { highlights, qualifications } = props;

    return (
        <LayoutContainer>
            <div className={gridClasses.twoColumn}>
                <Breakpoint desktop>
                    {!!highlights && highlights.careerHighlightNote ? (
                        <>
                            <Text variant="h2">career highlights</Text>
                            <LayoutCell columns={2}>
                                <Text
                                    variant="body1"
                                    dataCy="careerHighlightNote"
                                    preserveFormat
                                >
                                    {highlights.careerHighlightNote}
                                </Text>
                            </LayoutCell>
                        </>
                    ) : null}
                </Breakpoint>

                {qualifications ? (
                    <div
                        className={classnames(
                            gridClasses.entireRow,
                            gridClasses.oneColumn
                        )}
                    >
                        <Text variant="h2">
                            qualifications
                        </Text>
                        <LeadJobQualificationsView
                            title="required"
                            leadJobQualifications={qualifications}
                            isRequired={true}
                        />
                        <LeadJobQualificationsView
                            title="preferred"
                            leadJobQualifications={qualifications}
                            isRequired={false}
                        />
                    </div>
                ) : null}
            </div>
        </LayoutContainer>
    );
};
